"use strict";
//@ts-nocheck
/**
 * Handle filter
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
Object.defineProperty(exports, "__esModule", { value: true });
const _main_1 = require("./_main");
_main_1.txGs1Base.panels = {};
_main_1.txGs1Base.panels.filter = {};
_main_1.txGs1Base.filter = {
    autosubmit: {
        initialize: function () {
            var $filter = $('[data-filter-panel]');
            if ($('form', $filter).length > 0) {
                // Hide submit button
                $('form', $filter).find('button').hide();
                // Submit form when one of the checkboxes changes
                $(':checkbox, :radio', $filter).on('change', function () {
                    _main_1.txGs1Base.activityIndicator.attach();
                    $(this).closest('form').trigger('submit');
                });
            }
        }
    },
    initialize: function () {
        'use strict';
        _main_1.txGs1Base.filter.autosubmit.initialize();
    }
};
exports.default = {};
